import type { FaireProductEntity } from "../../entity_types/product";

export const p_2nysbdrfpx: FaireProductEntity = {
  token: "p_2nysbdrfpx",
  type: "product",
  name: "I ❤️ Spicy Margs Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/bdbb615ea00e2444fbebf3c03be8e1a25e7a7d18a3c69cd129a27b9d6b993a79.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a68cd54049d65da43e831d904435e6d91df7d4edee1bd2c2c70286b85e4e6044.jpeg",
    "https://cdn.faire.com/fastly/6b8967107fdf3e4191d60f41c33205620889ab99c39f74db03db69a8a26e5055.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/22f7a62872f4c141568a9d21b8f3c5940446ace3cc03b0ec44bcf0e3fb72102e.jpeg",
    "https://cdn.faire.com/fastly/7b0c7bbeaa92a7afb22f63dca1dedd6eb94f8e66747f6b551e06cdb8b608f1e6.jpeg"
  ],
  priceDollars: 6.75,
  description: "Socks for the kind of plans that start with \"just one\" and end with licking the rim.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:12.304Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
